import { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { trackEvent } from 'analytics/trackFunctions'
import PageWrapper from 'components/PageWrapper'
import PrimaryButton from 'components/primaryButton'
import { CashoutMaintenance } from 'assets/icons'
import { NewCardButton } from 'components/CardButtons'
import Separator from 'pages/signin/components/separator'
import { MeContext } from 'contexts/me'
import { redirectWhatsApp } from 'utils/redirectWhatsApp'
import { hasActiveMembership } from 'utils'
import { ZENDESK_URL } from 'config'

const UnavailableCashout = () => {
  const navigate = useNavigate()
  const { me } = useContext(MeContext)

  useEffect(() => {
    trackEvent({ eventName: 'bille_pantalla_transferencias_no_disponibles' })
  }, [])

  return (
    <PageWrapper noTabBar title='Transferencia' viewSelected='/movimientos'>
      <section className='h-[calc(100vh-12rem)] sm:h-full text-center text-black mx-auto justify-center sm:max-w-[22.5rem]'>
        <div className='h-full font-medium space-y-5'>
          <CashoutMaintenance className='mx-auto' />
          <h2 className='text-xl font-bold'>
            Transferencias no disponibles por el momento
          </h2>
          <div>
            <p>
              Estamos trabajando para restablecer el servicio lo antes posible.
            </p>
            <p>Gracias por tu paciencia y confianza.</p>
          </div>
          <Separator
            className='text-xs font-normal text-gray-900 shrink-0'
            text='Mientras, te ofrecemos estas opciones'
          />
          <NewCardButton onClick={() => navigate('/mis-tarjetas')}>
            <div className='text-xs'>
              <p className='font-bold text-purple-900'>
                Hacé compras con tus tarjetas
              </p>
              <p>Utilizá tu tarjeta física o virtual</p>
            </div>
          </NewCardButton>
          {hasActiveMembership(me?.subscriber_products) ? (
            <NewCardButton onClick={() => redirectWhatsApp(me?.profile?.name)}>
              <div className='text-xs'>
                <p className='font-bold text-purple-900'>
                  Hablar con un asesor
                </p>
                <p>Comunicate con nosotros vía WhatsApp</p>
              </div>
            </NewCardButton>
          ) : (
            <NewCardButton
              onClick={() =>
                window.open(`${ZENDESK_URL}/requests/new`, '_blank')
              }
            >
              <div className='text-xs'>
                <p className='font-bold text-purple-900'>
                  Comunicate con nosotros
                </p>
                <p>Resolvé tus consultas por correo</p>
              </div>
            </NewCardButton>
          )}
        </div>
        <PrimaryButton
          outlined
          buttonText='Volver al inicio'
          className='mt-auto sm:mt-5'
          primaryButtonFunction={() => navigate('/home')}
        />
      </section>
    </PageWrapper>
  )
}

export default UnavailableCashout
